import { cartHasPrime } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const PrimeSavings = (props) => {
  const { cart, settings } = props;
  if (!cartHasPrime(cart)) {
    return null;
  }
  if (!cart.shipping || cart.shipping.length === 0) {
    return null;
  }
  if (cart.shipping[0].price === 0 && cart.shipping[0].originalPrice !== 0) {
    return (
      <div className="c7-cart-summary__promotion-message">
        <div>
          <em>
            Saved with <span className="icon-star-shipping" /> Star Shipping:
          </em>
        </div>
        <div>{currencyFormat(cart.shipping[0].originalPrice, settings)}</div>
      </div>
    );
  }
  return null;
};

export default PrimeSavings;
